import type { ApiClient } from '../client';

// Force a «Entrega» to non_collected (manual empty-pickup override). The id rides the path
// (url-encoded); the client attaches the Firebase token via the Authorization header. Empty 200 —
// nothing to parse; the caller refetches the detail to surface the new state and the «Recogida
// vacía» row.
export async function nonCollectDelivery(client: ApiClient, id: string): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/non-collect`);
}
